export default "__VITE_ASSET__Ba6onXIa__"